import React, { useState } from 'react'

const styles = {
  inputContainer: {
    position: 'relative',
    marginLeft: '1em'
  },
  inputField: {
    width: '95%',
    height: '48px',
    fontSize: '14px',
    color: '#000000',
    fontFamily: 'JioType-Medium',
    display: 'block',
    border: 'none',
    paddingBottom: '21px',
    paddingTop: '20px',
    paddingLeft: '16px',
    border: '0.6px solid #D7D7D7',
    borderRadius: '10px',
    outline: 'none'
  },
  errorMsgContainer: {
    fontFamily: 'JioType-Medium',
    position: 'absolute',
    fontSize: '12px',
    color: '#EB0000',
    paddingTop: '-20px',
    width: '95%',
  },
  errorMsgContainerLengthy: {
    fontFamily: 'JioType-Medium',
    position: 'absolute',
    fontSize: '12px',
    color: '#EB0000',
    width: '95%',
  },
  labelAfter: {
    color: '#959595',
    fontSize: '12px',
    fontFamily: 'JioType-Light',
    paddingLeft: '16px',
    width: '100%',
    paddingTop: '0.5em',
    marginTop: '-62px'
  },
  label: {
    fontSize: '14px',
    color: '#7D7D7D',
    fontFamily: 'JioType-Medium',
    position: 'absolute',
    pointerEvents: 'none',
    paddingLeft: '16px',
    marginTop: '-35px',
    transition: '0.2s ease all',
    MozTransition: '0.2s ease all',
    WebkitTransition: '0.2s ease all'
  },
  focusInput: {
    fontFamily: 'JioType-Medium',
    marginTop: '-45px',
    fontSize: '8px',
    color: '#959595',
  }
}
const TextField = (props) => {
  const { errorText = '', inputRef = null, background } = props
  const [styling, setStyling] = useState('label')
  const changeStyling = (key) => {
    setStyling(key)
  }

  const handleBlur = (e) => {
    setStyling('label')
    props.onBlur(e)
  }

  return (
    <div style={styles.inputContainer}>
      <input
        style={{ ...styles.inputField, ...background }}
        ref={inputRef}
        value={props.value}
        label={props.label}
        onChange={props.onChange}
        required
        onBlur={handleBlur}
        mask={props.mask}
        type={props.type}
        maxLength={props.maxLength}
        pattern={props.pattern}
        placeholder={props.placeholder}
        name={props.name}
        onFocus={() => changeStyling('focusInput')}
        disabled={props.disabled || false}
        autoFocus={props.autoFocus}
      />
      {errorText.length < 55
        ? <div style={styles.errorMsgContainer}>{errorText}</div>
        : <div style={styles.errorMsgContainerLengthy}>{errorText}</div>}
      {(props.disabled && props.value) ? <label style={{ ...styles.labelAfter }}>{props.label}</label> :
        (props.value ? <label style={{ ...styles.label, ...styles.focusInput }} >{props.label}</label>
          : <label style={{ ...styles.label, ...styles[styling] }} >{props.label}</label>
        )}
    </div>
  )
}

export default TextField
